{
  "general": {
    "title": "Sammenlign muligheder",
    "intro": "Et hurtigt overblik over forskellene mellem Fællesskab, Abonnement og Engangskøb.",
    "tableheader": "Abonnement",
    "note1": "* Der findes muligheder for gruppeindkøb og mængderabat",
    "note2": "** Understøttede sprog er Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Kræver en gratis fælleskonto hos myboardmaker.com og er kun tiltænkt opbevaring af aktiviteter."
  },
  "mobileHeadings": {
    "community": "Fællesskab",
    "onetime": "Engangskøb*",
    "personal": "Personligt abonnement",
    "professional": "Professionelt abonnement",
    "organization": "Organisationsabonnement*"
  },
  "columnHeadings": {
    "community": "FÆLLESSKAB",
    "onetime": "ENGANGSKØB*",
    "personal": "PERSONLIGT ABONNEMENT",
    "professional": "PROFESSIONELT ABONNEMENT",
    "organization": "ORGANISATIONSABONNEMENT*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktiveringer",
    "languages": "Sprog**",
    "licensing": "Licensering",
    "pcsSymbols": "PCS Symbols",
    "templates": "Skabeloner",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Afspilning af aktiviteter som underviser",
    "playActivitiesStudent": "Afspilning af aktiviteter som elev",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Underviseradministration",
    "studentManagement": "Elevadministration",
    "assignStudentActivities": "Tildel elevaktiviteter",
    "cloudStorage": "Cloudlager",
    "createAndJoin": "Opret og kom med i grupper",
    "accessCommunity": "Adgang til over 120 tusinde fællesskabsaktiviteter",
    "shareActivity": "Del aktiviteter i fællesskab",
    "curriculum": "Undervisningsplan og indhold",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Premium Activities",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 enheder",
    "unlimited": "Ubegrænset",
    "byKey": "Licensnøgle",
    "symbols": "80000+",
    "templates": "600+",
    "languages": "12",
    "login": "Log ind",
    "yes": "Ja",
    "yesNote": "Ja***",
    "no": "Nej"
  }
}